import texts from '@components/Calculators/fd/en.json';
import { theme } from '@ui/tailwind.config';


export const fdCalculatorDefaultValues = {
    totalInvestment: 1000000,
    rate: 9.5,
    time: 4,
};

export const fdCalculatorFields = {
    totalInvestment: {
        id: 'monthlyInvestment',
        fieldName: texts?.TotalInvestment,
        prefix: '₹',
        width: 'w-[107px]',
        sliderInterval: 5000,
        minValue: 1000,
        maxValue: 10000000,
        maxLength: 11,
        shouldFormatValue: true,
        showLimit: true,
        className: 'text-left',
    },
    expectedRateOfReturn: {
        id: 'expectedRateOfReturn',
        fieldName: texts?.ExpectedRateOfReturn,
        suffix: '%',
        width: 'w-10',
        sliderInterval: 0.1,
        minValue: 1,
        maxValue: 12,
        maxLength: 5,
        showLimit: true,
    },
    timePeriod: {
        id: 'timePeriod',
        fieldName: texts?.TimePeriod,
        suffix: 'years',
        suffixSingular: 'year',
        width: 'w-10',
        sliderInterval: 1,
        minValue: 1,
        maxValue: 25,
        maxLength: 3,
        shouldFormatValue: true,
        showLimit: true,
    },
};

export const getFdPieChartData = (calculatedValue) => [
    {
        name: 'Total invested',
        value: calculatedValue.totalInvested,
        color: theme.colors.primary?.[500],
    },
    {
        name: 'Estimated returns',
        value: calculatedValue.estimatedReturns,
        color: theme.colors.primary?.[70],
    },
];
